import React from 'react'
import {
    Datagrid,
    Edit,
    ReferenceManyField,
    SimpleForm,
    TextField,
    TextInput,
    required,
} from 'react-admin'

import { PERMISSIONS } from '../../constants'
import Permission from '../../components/Permission'
import ListPagination from '../../components/ListPagination'

const edit = ({ ...props }) => (
    <Permission permission={PERMISSIONS.ADMIN}>
        <Edit {...props} title="Editar grupo de permissões">
            <SimpleForm sx={{ maxWidth: '100%' }}>
                <TextInput source="name" label="Nome" validate={required()} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
                <ReferenceManyField
                    label="Permissões do grupo"
                    reference="user-permissions"
                    target="groupId"
                    pagination={<ListPagination />}
                    perPage={25}
                    // storeKey={false} desliga a sincronização de seleção com o store.
                    // Sem isso, o react-admin grava `user-permissions.selectedIds.storeKeys`,
                    // que no memoryStore (baseado em lodash.set, que trata "." como path)
                    // sobrescreve `user-permissions.selectedIds` de array para objeto e
                    // quebra a lista de Permissões com "selectedIds.includes is not a function".
                    // O runtime do RA aceita `false` (vide JSDoc do useRecordSelection),
                    // mas o type está como `string` — daí o cast.
                    storeKey={false as unknown as string}
                >
                    <Datagrid bulkActionButtons={false} rowClick="edit">
                        <TextField source="name" label="Nome" />
                        <TextField source="label" label="Descrição" />
                    </Datagrid>
                </ReferenceManyField>
            </SimpleForm>
        </Edit>
    </Permission>
)

export default edit
